import React from 'react';
import CalculatorForm from '../CalculatorForm/CalculatorForm.js';
import { Flex, Box } from '@zillow/constellation';
import { FieldConfig, OPTIONS_LOAN_TYPE, CREDIT_SCORE_BUCKETS, OPTIONS_LTV, OPTIONS_TIMESPAN } from './MortgageRateTrends.utils.js';
import { omitUndefined } from '../../utils/lodash.js';
import MortgageRateTrendsFields from './MortgageRateTrendsFields.js';
import MortgageRateTrendsChart from './MortgageRateTrendsChart.js';
import LegalDisclosuresModal from '../LegalDisclosuresModal/LegalDisclosuresModal.js';
import { useWatch } from 'react-hook-form';

var MortgageRateTrends = function MortgageRateTrends(_ref) {
  var _Object$assign;
  var defaultValues = _ref.defaultValues,
    editorMode = _ref.editorMode,
    blockData = _ref.blockData;
  var finalDefaultValues = Object.assign((_Object$assign = {}, _Object$assign[FieldConfig.loanPurpose.name] = OPTIONS_LOAN_TYPE.Refinance, _Object$assign[FieldConfig.creditRating.name] = CREDIT_SCORE_BUCKETS.VeryHigh, _Object$assign[FieldConfig.Fixed30Year.name] = true, _Object$assign[FieldConfig.location.name] = 'United States', _Object$assign[FieldConfig.percentDown.name] = OPTIONS_LTV.Normal, _Object$assign[FieldConfig.timeSpan.name] = OPTIONS_TIMESPAN.OneYear, _Object$assign), omitUndefined(defaultValues));
  return /*#__PURE__*/React.createElement(CalculatorForm, {
    fieldStorageKey: "mortgageratetrendsfields",
    defaultValues: finalDefaultValues,
    editorMode: editorMode
  }, /*#__PURE__*/React.createElement(Flex, {
    display: "flex",
    flexDirection: {
      default: 'column',
      xxl: 'row'
    }
  }, /*#__PURE__*/React.createElement(Flex, {
    marginRight: {
      xxl: 'xs'
    },
    order: {
      default: 2,
      xxl: 1
    }
  }, /*#__PURE__*/React.createElement(MortgageRateTrendsFields, null)), /*#__PURE__*/React.createElement(Flex, {
    tabindex: "0",
    flex: "1",
    order: {
      default: 1,
      xxl: 2
    },
    as: "figure",
    role: "group"
  }, /*#__PURE__*/React.createElement(MortgageRateTrendsChart, null))), /*#__PURE__*/React.createElement(Box, {
    sx: {
      marginTop: '$spacing.sm'
    }
  }, /*#__PURE__*/React.createElement(LegalDisclosuresModalWithRefinanceValue, {
    rates: blockData === null || blockData === void 0 ? void 0 : blockData.rates
  })));
};
var LegalDisclosuresModalWithRefinanceValue = function LegalDisclosuresModalWithRefinanceValue(_ref2) {
  var rates = _ref2.rates;
  var loanPurpose = useWatch({
    name: FieldConfig.loanPurpose.name
  });
  return /*#__PURE__*/React.createElement(LegalDisclosuresModal, {
    classification: {
      refinance: loanPurpose === 'Refinance'
    },
    rates: rates || {}
  });
};
var MortgageRateTrends$1 = MortgageRateTrends;

export { MortgageRateTrends$1 as default };
